import Image from "next/image";

import noImage from "@images/no-image.jpg";

const BLUR_DATA_URL =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAZAAAAGQAQMAAAC6caSPAAAAAXNSR0IB2cksfwAAAAlwSFlzAAAWJQAAFiUBSVIk8AAAAANQTFRF7vD13W0nXgAAACpJREFUeJztwTEBAAAAwqD1T+1vBqAAAAAAAAAAAAAAAAAAAAAAAAAAgDdPsAABORaXeAAAAABJRU5ErkJggg==";

const NxtImage = ({ src, noBlur = false, ...rest }) => (
  <Image
    src={src || noImage}
    alt="image"
    placeholder={noBlur ? "empty" : "blur"}
    blurDataURL={BLUR_DATA_URL}
    {...rest}
  />
);

export default NxtImage;
